import React from "react"

import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch"

const deleteOfferLink = (
    backend: string,
    token: string,
    id: number
) => {
    return fetch(
        `${getApiUrl(backend)}offer_links/${id}`,
        {
            method: 'DELETE',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
        }
    );
};

export default deleteOfferLink;
